var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdsObjectiveMarketplace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_10505_56288)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1,
    width: 48,
    height: 48,
    rx: 12,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 1.5,
    width: 47,
    height: 47,
    rx: 11.5,
    stroke: "#F9ED33",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1501 37.5415H22.8501C17.0867 37.5415 14.6367 35.0798 14.6367 29.3282V24.0898C14.6367 23.6115 15.0334 23.2148 15.5117 23.2148C15.9901 23.2148 16.3867 23.6115 16.3867 24.0898V29.3282C16.3867 34.0998 18.0784 35.7915 22.8501 35.7915H29.1384C33.9101 35.7915 35.6017 34.0998 35.6017 29.3282V24.0898C35.6017 23.6115 35.9984 23.2148 36.4767 23.2148C36.9551 23.2148 37.3517 23.6115 37.3517 24.0898V29.3282C37.3634 35.0798 34.9017 37.5415 29.1501 37.5415Z",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9998 25.8737C24.7165 25.8737 23.5498 25.372 22.7215 24.4504C21.8932 23.5287 21.5082 22.327 21.6365 21.0437L22.4182 13.2504C22.4648 12.807 22.8382 12.457 23.2932 12.457H28.7415C29.1965 12.457 29.5698 12.7954 29.6165 13.2504L30.3982 21.0437C30.5265 22.327 30.1415 23.5287 29.3132 24.4504C28.4498 25.372 27.2832 25.8737 25.9998 25.8737ZM24.0748 14.207L23.3748 21.2187C23.2932 22.0004 23.5265 22.7354 24.0165 23.272C25.0082 24.3687 26.9915 24.3687 27.9832 23.272C28.4732 22.7237 28.7065 21.9887 28.6248 21.2187L27.9248 14.207H24.0748Z",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.362 25.8737C30.9937 25.8737 28.882 23.9604 28.637 21.6037L27.8203 13.4254C27.797 13.1804 27.8787 12.9354 28.042 12.7487C28.2053 12.562 28.4387 12.457 28.6953 12.457H32.2537C35.6837 12.457 37.282 13.892 37.7603 17.4154L38.087 20.6587C38.227 22.0354 37.807 23.342 36.9087 24.3337C36.0103 25.3254 34.7503 25.8737 33.362 25.8737ZM29.6637 14.207L30.387 21.4287C30.5387 22.887 31.892 24.1237 33.362 24.1237C34.2487 24.1237 35.042 23.7854 35.6137 23.167C36.1737 22.5487 36.4303 21.7204 36.3487 20.8337L36.022 17.6254C35.6603 14.9887 34.8087 14.207 32.2537 14.207H29.6637Z",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5795 25.8737C17.1912 25.8737 15.9312 25.3254 15.0329 24.3337C14.1345 23.342 13.7145 22.0354 13.8545 20.6587L14.1695 17.4504C14.6595 13.892 16.2579 12.457 19.6879 12.457H23.2462C23.4912 12.457 23.7245 12.562 23.8995 12.7487C24.0745 12.9354 24.1445 13.1804 24.1212 13.4254L23.3045 21.6037C23.0595 23.9604 20.9479 25.8737 18.5795 25.8737ZM19.6879 14.207C17.1329 14.207 16.2812 14.977 15.9079 17.6487L15.5929 20.8337C15.4995 21.7204 15.7679 22.5487 16.3279 23.167C16.8879 23.7854 17.6812 24.1237 18.5795 24.1237C20.0495 24.1237 21.4145 22.887 21.5545 21.4287L22.2779 14.207H19.6879Z",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9163 37.5404H23.083C22.6047 37.5404 22.208 37.1437 22.208 36.6654V33.7487C22.208 31.2987 23.5497 29.957 25.9997 29.957C28.4497 29.957 29.7913 31.2987 29.7913 33.7487V36.6654C29.7913 37.1437 29.3947 37.5404 28.9163 37.5404ZM23.958 35.7904H28.0413V33.7487C28.0413 32.2787 27.4697 31.707 25.9997 31.707C24.5297 31.707 23.958 32.2787 23.958 33.7487V35.7904Z",
    fill: "#292D32"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_10505_56288",
    x: 0,
    y: 0,
    width: 52,
    height: 52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10505_56288"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10505_56288",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdsObjectiveMarketplace);
export default __webpack_public_path__ + "static/media/ads-objective-marketplace.850a3978ece1f7a0e1e8fddae43130bb.svg";
export { ForwardRef as ReactComponent };